angular.module('am4')
.factory('nonconnectedMachineService', function($http, $q, equipmentGroupService, apiUrl) {
    return {
        getFacilityNonconnectedMachines: function(facility_id) {
            return $http({
                method: 'GET',
                url: apiUrl + '/nonconnected_machines',
                params: {
                    facilities: facility_id
                }
            })
            .then(function(res) {
                return res.data;
            });
        },
        getNonconnectedMachineById: function(ncmachine_id) {
            return $http.get(apiUrl + '/nonconnected_machines/' + ncmachine_id)
            .then(function(res) {
                return res.data;
            });
        },
        postNonconnectedMachine: function(machineData) {
            return $http.post(apiUrl + '/nonconnected_machines', angular.toJson(machineData))
            .then(function(res) {
                return res.data;
            });
        },
        putNonconnectedMachine: function(machineData, machine_id) {
            // use angular.toJson to strip $$hashKeys from object
            return $http.put(apiUrl + '/nonconnected_machines/' + machine_id, angular.toJson(machineData))
            .then(function(res) {
                return res.data;
            });
        },
        deleteNonconnectedMachine: function(machine_id, facility_id) {
            return equipmentGroupService.getNonconnectedMachineEquipmentGroups(facility_id, machine_id)
            .then(function(groups) {
                if (groups.length) {
                    var promises = [];
                    groups.forEach(function(group) {
                        promises.push(equipmentGroupService.removeNonconnectedMachineFromEquipmentGroup(facility_id, machine_id, group.id));
                    });

                    return $q.all(promises);
                }
                return $q.when(true);

            })
            .then(function() {
                return $http({
                    method: 'DELETE',
                    url: apiUrl + '/nonconnected_machines/' + machine_id
                });
            })
            .then(function(res) {
                return res.data;
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/nonconnectedMachine.js